import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import { AxiosRequestConfig } from "axios";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    allow403?: boolean;
}

export const getBranches = (
  {
    currentPage,
    pageSize,
    params = {}
  }: {
    currentPage: number;
    pageSize: number;
    params?: Record<string, string | number | boolean | undefined>;
  }
) => {
  const queryParams: Record<string, string | number | boolean> = {
    page: currentPage,
    page_size: pageSize,
    ...params
  };
  return axiosPrivate.get("/dashboard/api/v1/terminals_branch", { params: queryParams });
};

export type BranchBody = {
  branch_id: string;
  branch_name: string;
  city: string;
  address: string;
};

export type CreateBranchBody = BranchBody;
export type UpdateBranchBody = BranchBody;


export const createBranch = (body: CreateBranchBody) => {
  return axiosPrivate.post("/dashboard/api/v1/terminals_branch", body,  { allow403: true } as CustomAxiosRequestConfig);
};

export const updateBranch = (branchId: string, body: UpdateBranchBody) => {
  return axiosPrivate.put(`/dashboard/api/v1/terminals_branch?branch_id=${branchId}`, body);
};